<template>
  <div class="d-block px-2 py-3">
    <v-card outlined elevation="0" id="filter-card" class="mb-5">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" sm="4" class="py-0" :class="(isMobile) ? 'mb-3' : 'pr-0'">
              <div class="d-block mb-2 font-weight-bold" v-if="isMobile">Tanggal Pembelian</div>
              <v-menu
                ref="menuDate"
                v-model="menuDate"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    clearable
                    densed
                    class="datePickerSmall"
                    placeholder="Tanggal"
                    @click:clear="clearDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.dateRange"
                  no-title
                  @click:date="searchPO"
                  @change="tglTransaksiFilter.value = filter.dateRange"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="2" class="py-0">
              <v-combobox
                v-model="filter.type"
                dense
                outlined
                item-text="label"
                item-value="value"
                hide-details="auto"
                :items="filterOptions"
                class="d-none"
              ></v-combobox>
            </v-col>

            <v-col cols="12" sm="6" class="py-0">
              <div class="d-block mb-2 font-weight-bold" v-if="isMobile">Nomor Pembelian</div>
              <v-text-field
                v-model="filter.search"
                outlined
                small
                dense
                clearable
                hide-details="auto"
                class="searchInput"
                @input="poNoFilter.value = filter.search"
                @click:clear="clearSearch"
                @keyup.enter="searchPO"
                placeholder="Cari nomor pembelian"
              >
                <div slot="append">
                  <v-btn small elevation="2" color="black" class="white--text" @click="searchPO">
                    <v-icon center>mdi-magnify</v-icon>
                  </v-btn>
                </div>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-layout v-resize="onResize" column>
      <v-data-table
        v-model="selected"
        :server-items-length="pembelianPagination.total_data"
        :items="listPembelian"
        :loading="loadingList"
        :headers="headers"
        :expanded.sync="expanded"
        :hide-default-header="true"
        :hide-default-footer="true"
        item-key="po_id"
        show-expand
        single-expand
        class="elevation-1 border"
        :class="{mobile: isMobile}"
        id="order-table"
        @item-expanded="loadDetailPembelian"
      >
        <template v-slot:item.po_code="{ item }">
          <v-row class="d-flex flex-row align-start pa-3">
            <!-- item:: {{item}} -->
            <v-col
              cols="12"
              sm="3"
              class="d-flex flex-column align-start justify-start"
              :class="(isMobile) ? 'pt-1 pb-2' : 'py-0'"
            >
              <div class="text-subtitle-2 font-weight-bold">No. Pembelian</div>
              <span class="font-weight-bold no-line black--text font-weight-bold">{{ item.po_code }}</span>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="d-flex flex-column align-start justify-start"
              :class="(isMobile) ? 'pt-1 pb-2' : 'py-0'"
            >
              <div class="text-subtitle-2 font-weight-bold">Tanggal Pembelian</div>
              <span>{{ formatDateText(item.po_status_created_datetime, 'DD MMM YYYY HH:mm') }}</span>
              <div
                v-if="item.po_status=='created'"
                class="text-subtitle-2 font-weight-bold"
              >Batas Transaksi</div>
              <span
                class="red--text"
                v-if="item.po_status=='created'"
              >{{ formatDateText(item.trx_limit_confirmation_created, 'DD MMM YYYY HH:mm') }}</span>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="d-flex flex-column align-start justify-start"
              :class="(isMobile) ? 'pt-1 pb-2' : 'py-0'"
            >
              <div class="text-subtitle-2 font-weight-bold">Total Pembelian</div>
              <span>{{ item.po_price_grand_total | toRupiah }}</span>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="d-flex flex-column align-start justify-start"
              :class="(isMobile) ? 'pt-1 pb-2' : 'py-0'"
            >
              <div class="text-subtitle-2 font-weight-bold">Status</div>
              <v-chip
                small
                label
                class="mt-2 font-weight-bold"
                :class="colorStatus(item.po_status)"
              >{{ statusCaption(item.po_status) }}</v-chip>
            </v-col>
          </v-row>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="mb-2" v-if="!loadingDetail">
            <v-row class="mb-1">
              <v-col cols="12" class="text-left py-0">
                <template v-if="!isMobile">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="text-left" width="46%">Info Produk</th>
                        <th class="text-right" width="20%">Jumlah Harga</th>
                        <th class="text-center" width="17%">Jumlah Dipesan</th>
                        <th class="text-center" width="17%">Jumlah Diterima</th>
                      </tr>
                    </thead>
                    <tbody v-if="!loadingDetail">
                      <template v-for="(produk, idp) in detailPembelian.po_detail">
                        <tr :key="idp">
                          <td>
                            <div class="d-flex flex-row align-center">
                              <v-img
                                width="70"
                                max-width="70"
                                class="mr-4"
                                :src="(produk.po_detail_product_image[0]) ? produk.po_detail_product_image[0] : '/assets/product/default.png'"
                              ></v-img>
                              <div class="d-flex flex-column align-start">
                                <div
                                  class="font-weight-bold no-line black--text"
                                >{{ produk.po_detail_product_code }} - {{ produk.po_detail_product_name }}</div>
                                <div
                                  class="text-caption"
                                >berat {{ produk.po_detail_product_weight | toKg }} @ {{ (produk.po_detail_product_price) | toRupiah }}</div>
                              </div>
                            </div>
                          </td>
                          <td
                            class="text-right"
                          >{{ (produk.po_detail_quantity_requested * produk.po_detail_product_price) | toRupiah }}</td>
                          <td class="text-center">{{ produk.po_detail_quantity_requested }}</td>
                          <td class="text-center">{{ produk.po_detail_quantity_delivered }}</td>
                        </tr>
                      </template>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="4">
                          <div class="d-block text-center pa-4 text-caption">Loading...</div>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="4" class="px-0">
                          <template
                            v-if="detailPembelian.po_status !== 'created' && detailPembelian.po_status !== 'pending'"
                          >
                            <hr />
                            <v-row class="align-start ma-0">
                              <v-col cols="6">
                                <v-card elevation="0" flat>
                                  <v-card-title class="pa-0 pb-3">
                                    <span class="text-subtitle-2">Catatan Seller</span>
                                  </v-card-title>
                                  <v-card-text
                                    class="pa-0"
                                  >{{ detailPembelian.po_note | emptyData }}</v-card-text>
                                </v-card>
                              </v-col>
                              <v-col cols="6">
                                <v-card elevation="0" flat>
                                  <v-card-title class="pa-0 pb-3">
                                    <span class="text-subtitle-2">Info Pengiriman</span>
                                  </v-card-title>
                                  <v-card-text class="pa-0">
                                    <template v-if="detailPembelian.po_courier_resi">
                                      <v-row>
                                        <v-col
                                          cols="5"
                                          class="py-0"
                                          v-if="detailPembelian.po_agregator!='kiriminaja' && detailPembelian.po_shipping_method=='courier'"
                                        >
                                          <div class="d-flex flex-column">
                                            <strong class="mr-2">Nomor Resi</strong>
                                            {{ detailPembelian.po_courier_resi | emptyData }}
                                          </div>
                                        </v-col>
                                        <v-col
                                          cols="5"
                                          class="py-0"
                                          v-if="detailPembelian.po_agregator=='kiriminaja' && detailPembelian.awb_kiriminaja!=null"
                                        >
                                          <div class="d-flex flex-column">
                                            <strong class="mr-2">Nomor Resi</strong>
                                            {{ detailPembelian.awb_kiriminaja | emptyData }}
                                          </div>
                                        </v-col>
                                        <!-- <v-col cols="5" class="py-0" v-else>
                                          <div class="d-flex flex-column">
                                            <strong class="mr-2">Ambil Di Toko (Pick-up)</strong>
                                          </div>
                                        </v-col>-->
                                        <v-col
                                          v-else-if="detailPembelian.po_shipping_method=='pick_up'"
                                          cols="5"
                                          class="py-0"
                                        >
                                          <div class="d-flex flex-column">
                                            <strong class="mr-2">Ambil Di Toko (Pick-up)</strong>
                                          </div>
                                        </v-col>
                                        <v-col cols="7" class="py-0">
                                          <div class="d-flex flex-column">
                                            <strong
                                              class="mr-2"
                                            >{{ (detailPembelian.po_courier_code) ? detailPembelian.po_courier_code.toUpperCase() : '' }} {{ (detailPembelian.po_courier_service) ? '- ' + detailPembelian.po_courier_service : '' }}</strong>
                                            <span
                                              v-if="detailPembelian.po_courier_etd"
                                            >Estimasi {{ detailPembelian.po_courier_etd }}</span>
                                            <span>{{ detailPembelian.po_price_shipping | toRupiah }}</span>
                                          </div>
                                        </v-col>
                                      </v-row>
                                    </template>
                                    <template v-else>-</template>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                          </template>
                          <hr />
                          <v-row class="ma-0" v-if="!loadingTransaksi">
                            <v-col cols="6" class="px-0 pb-1">
                              <v-btn
                                outlined
                                dark
                                color="grey"
                                @click="dialogStatusPembelian = true"
                              >
                                <v-img
                                  width="20"
                                  src="/assets/seller/status-pesanan-no-padding.svg"
                                ></v-img>
                                <span
                                  class="text-subtitle-2 text-capitalize ml-2 font-weight-bold"
                                >Status Pembelian</span>
                              </v-btn>
                              <v-btn
                                v-if="detailPembelian.po_agregator!='kiriminaja'"
                                style="margin-left:5px;"
                                v-show="(detailPembelian.po_courier_resi!=null && detailPembelian.po_shipping_method=='courier')?true:false"
                                outlined
                                dark
                                color="grey"
                                :class="{'v-btn--block': isMobile}"
                                @click="lacakStatusPesanan = true"
                              >
                                <v-icon>mdi-truck</v-icon>
                                <span
                                  class="text-subtitle-2 text-capitalize font-weight-bold"
                                  :class="{'ml-2': !isMobile}"
                                >Lacak Pesanan</span>
                              </v-btn>
                              <v-btn
                                v-else
                                style="margin-left:5px;"
                                v-show="(detailPembelian.awb_kiriminaja!=null)?true:false"
                                outlined
                                dark
                                color="grey"
                                :class="{'v-btn--block': isMobile}"
                                @click="lacakStatusPesanan = true"
                              >
                                <v-icon>mdi-truck</v-icon>
                                <span
                                  class="text-subtitle-2 text-capitalize font-weight-bold"
                                  :class="{'ml-2': !isMobile}"
                                >Lacak Pesanan</span>
                              </v-btn>
                            </v-col>

                            <v-col cols="6" class="px-0 pb-1 text-right">
                              <!-- {{item}} -->
                              <v-btn
                                outlined
                                dark
                                color="black"
                                class="mr-2"
                                @click.native="printInvoice('po-' + item.po_id)"
                              >
                                <span
                                  class="text-subtitle-2 text-capitalize font-weight-bold"
                                >Invoice</span>
                              </v-btn>

                              <!-- <v-btn
                                color="black" class="white--text"
                                dark
                                @click="openConfirmBayar(item)"
                                v-if="item.po_status === 'created'"
                              >
                                <span
                                  class="text-subtitle-2 text-capitalize font-weight-bold"
                                >Konfirmasi Pembayaran</span>
                              </v-btn>-->
                              <v-btn
                                :loading="loadingBelanja"
                                color="warning"
                                dark
                                @click="openPayment(item)"
                                v-if="(item.po_status === 'created' && (item.trx_midtrans_type==null || item.trx_midtrans_type==''))"
                              >
                                <span
                                  class="text-subtitle-2 text-capitalize font-weight-bold"
                                >Pilih Pembayaran</span>
                              </v-btn>
                              <v-btn
                                :loading="loadingBelanja"
                                color="error"
                                dark
                                @click="doCancel(item)"
                                v-if="(item.po_status === 'created' && item.trx_midtrans_type!=null && item.trx_midtrans_type!='')"
                              >
                                <span
                                  class="text-subtitle-2 text-capitalize font-weight-bold"
                                >Batalkan</span>
                              </v-btn>

                              <template v-if="detailPembelian.po_agregator!='kiriminaja'">
                                <v-btn
                                  color="black"
                                  class="white--text"
                                  dark
                                  @click="openConfirmReceive(item)"
                                  v-if="item.po_status === 'processed'"
                                >
                                  <span
                                    class="text-subtitle-2 text-capitalize font-weight-bold"
                                  >Terima</span>
                                </v-btn>
                              </template>
                              <template v-else>
                                <v-btn
                                  color="black"
                                  class="white--text"
                                  dark
                                  @click="openConfirmReceive(item)"
                                  v-if="item.po_status === 'delivery'"
                                >
                                  <span
                                    class="text-subtitle-2 text-capitalize font-weight-bold"
                                  >Terima</span>
                                </v-btn>
                              </template>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                    </tfoot>
                  </v-simple-table>
                </template>

                <template v-else>
                  <div v-if="!loadingDetail">
                    <div>
                      <span class="text-subtitle-1 font-weight-bold black--text">Info Produk</span>
                    </div>
                    <template v-for="(produk, idp) in detailPembelian.po_detail">
                      <v-row :key="idp">
                        <v-col cols="12">
                          <hr class="mb-3 mb-0" />
                          <div class="d-flex flex-row align-center mb-2">
                            <v-img
                              width="70"
                              max-width="70"
                              class="mr-4"
                              :src="(produk.po_detail_product_image[0]) ? produk.po_detail_product_image[0] : '/assets/product/default.png'"
                            ></v-img>
                            <div class="d-flex flex-column align-start">
                              <div
                                class="font-weight-bold no-line black--text"
                              >{{ produk.po_detail_product_name }}</div>
                              <div
                                class="text-caption"
                              >berat {{ produk.po_detail_product_weight | toKg }} @ {{ (produk.po_detail_product_price) | toRupiah }}</div>
                            </div>
                          </div>

                          <v-row>
                            <v-col cols="5" class="py-1">
                              <span class="text-caption font-weight-bold black--text">Harga</span>
                            </v-col>
                            <v-col
                              cols="7"
                              class="py-1 text-right"
                            >{{ (produk.po_detail_quantity_requested * produk.po_detail_product_price) | toRupiah }}</v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="5" class="py-1">
                              <span class="text-caption font-weight-bold black--text">Dipesan</span>
                            </v-col>
                            <v-col
                              cols="7"
                              class="py-1 text-right"
                            >{{ produk.po_detail_quantity_requested }}</v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="5" class="pt-1 pb-0">
                              <span class="text-caption font-weight-bold black--text">Diterima</span>
                            </v-col>
                            <v-col
                              cols="7"
                              class="pt-1 pb-0 text-right"
                            >{{ produk.po_detail_quantity_delivered }}</v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>

                    <template
                      v-if="detailPembelian.po_status !== 'created' && detailPembelian.po_status !== 'pending'"
                    >
                      <v-row class="align-start">
                        <v-col cols="12" class="pt-1">
                          <v-card elevation="0" flat>
                            <v-card-title class="pa-2 pb-2">
                              <span class="text-subtitle-2 font-weight-bold">Catatan Seller</span>
                            </v-card-title>
                            <v-card-text class="pa-2">{{ detailPembelian.po_note | emptyData }}</v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" class="pt-1">
                          <v-card elevation="0" flat>
                            <v-card-title class="pa-2 pb-2">
                              <span class="text-subtitle-2 font-weight-bold">Info Pengiriman</span>
                            </v-card-title>
                            <v-card-text class="pa-2">
                              <template v-if="detailPembelian.po_courier_resi">
                                <v-row>
                                  <!-- <v-col
                                    v-if="detailPembelian.po_shipping_method=='courier'"
                                    cols="12"
                                    class="py-0"
                                  >
                                    <div class="d-flex flex-column">
                                      <strong class="mr-2">Nomor Resi</strong>
                                      {{ detailPembelian.po_courier_resi | emptyData }}
                                    </div>
                                  </v-col>-->
                                  <v-col
                                    cols="12"
                                    class="py-0"
                                    v-if="detailPembelian.po_agregator!='kiriminaja' && detailPembelian.po_shipping_method=='courier'"
                                  >
                                    <div class="d-flex flex-column">
                                      <strong class="mr-2">Nomor Resi</strong>
                                      {{ detailPembelian.po_courier_resi | emptyData }}
                                    </div>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    class="py-0"
                                    v-if="detailPembelian.po_agregator=='kiriminaja' && detailPembelian.awb_kiriminaja!=null"
                                  >
                                    <div class="d-flex flex-column">
                                      <strong class="mr-2">Nomor Resi</strong>
                                      {{ detailPembelian.awb_kiriminaja | emptyData }}
                                    </div>
                                  </v-col>
                                  <v-col
                                    v-else-if="detailPembelian.po_shipping_method=='pick_up'"
                                    cols="12"
                                    class="py-0"
                                  >
                                    <div class="d-flex flex-column">
                                      <strong class="mr-2">Ambil Di Toko (Pick-up)</strong>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" class="py-0">
                                    <div class="d-flex flex-column">
                                      <strong
                                        class="mr-2"
                                      >{{ (detailPembelian.po_courier_code) ? detailPembelian.po_courier_code.toUpperCase() : '' }} {{ (detailPembelian.po_courier_service) ? '- ' + detailPembelian.po_courier_service : '' }}</strong>
                                      <span
                                        v-if="detailPembelian.po_courier_etd"
                                      >Estimasi {{ detailPembelian.po_courier_etd }}</span>
                                      <span>{{ detailPembelian.po_price_shipping | toRupiah }}</span>
                                    </div>
                                  </v-col>
                                </v-row>
                              </template>
                              <template v-else>-</template>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </template>
                    <hr />

                    <v-row class="ma-0" v-if="!loadingTransaksi">
                      <v-col cols="12" class="px-0 pb-3 text-right">
                        <template
                          v-if="item.po_status === 'created' || item.po_status === 'processed'"
                        >
                          <v-btn
                            color="black"
                            class="white--text"
                            dark
                            block
                            @click="openConfirmBayar(item)"
                            v-if="item.po_status === 'created'"
                          >
                            <span
                              class="text-subtitle-2 text-capitalize font-weight-bold"
                            >Konfirmasi Pembayaran</span>
                          </v-btn>
                          <!-- <v-btn
                            color="black"
                            class="white--text"
                            dark
                            block
                            @click="openConfirmReceive(item)"
                            v-if="item.po_status === 'processed'"
                          >
                            <span class="text-subtitle-2 text-capitalize font-weight-bold">Terima</span>
                          </v-btn>-->
                          <template v-if="detailPembelian.po_agregator!='kiriminaja'">
                            <v-btn
                              color="black"
                              class="white--text"
                              dark
                              block
                              @click="openConfirmReceive(item)"
                              v-if="item.po_status === 'processed'"
                            >
                              <span class="text-subtitle-2 text-capitalize font-weight-bold">Terima</span>
                            </v-btn>
                          </template>
                          <template v-else>
                            <v-btn
                              color="black"
                              class="white--text"
                              dark
                              block
                              @click="openConfirmReceive(item)"
                              v-if="item.po_status === 'delivery'"
                            >
                              <span class="text-subtitle-2 text-capitalize font-weight-bold">Terima</span>
                            </v-btn>
                          </template>
                        </template>

                        <v-btn
                          outlined
                          dark
                          color="black"
                          :class="(isMobile) ? 'v-btn--block mt-5' : 'ml-2'"
                          @click="printInvoice('po-' + item.po_id)"
                          v-if="isMobile"
                        >
                          <span class="text-subtitle-2 text-capitalize font-weight-bold">Invoice</span>
                        </v-btn>
                      </v-col>

                      <v-col cols="12" class="px-0 pt-0 pb-1">
                        <v-btn
                          dark
                          block
                          color="white"
                          class="black--text"
                          @click="dialogStatusPembelian = true"
                        >
                          <span
                            class="text-subtitle-2 text-capitalize font-weight-bold"
                          >Status Pembelian</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else>
                    <div class="d-block text-center pa-4 text-caption">Loading...</div>
                  </div>
                </template>
              </v-col>
            </v-row>
          </td>

          <td :colspan="headers.length" v-else>
            <div class="d-block text-center pa-4 text-caption">loading...</div>
          </td>
        </template>

        <template v-slot:no-data>
          <div class="d-flex flex-column align-center py-5 px-5">
            <v-img
              width="100"
              height="100"
              max-width="100"
              class="py-5 my-4"
              src="/assets/seller/belum-ada-pesanan.svg"
            ></v-img>
            <div
              class="text-subtitle-1 black--text font-weight-bold"
            >Tidak ada data pembelian yang dapat ditampilkan.</div>
          </div>
        </template>
      </v-data-table>
    </v-layout>

    <v-pagination
      v-if="pembelianPagination.total_page > 1 && listPembelian.length > 0"
      @input="updatePage"
      v-model="page"
      :length="pembelianPagination.total_page"
      total-visible="7"
      circle
      color="black"
      class="d-flex justify-end no-button-focus py-2"
    ></v-pagination>

    <v-dialog v-model="dialogConfirmBayar" persistent :max-width="(!confirmPayment) ? 700 : 500">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text"
          v-if="!isMobile"
        >Konfirmasi Pembayaran Pembelian Produk</v-card-title>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text" v-else>
          Konfirmasi Pembayaran
          <br />Pembelian Produk
        </v-card-title>
        <v-card-text
          class="pt-2 pb-0 px-5"
          :class="(!isMobile) ? 'mx-1' : ''"
          v-if="!confirmPayment"
        >
          <v-form ref="formPayment" role="form" class="pa-5 border">
            <v-row class="align-center mb-4">
              <v-col cols="12" sm="4" class="py-0">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Metode Pembayaran</div>
              </v-col>
              <v-col cols="12" sm="8" class="py-0">
                <v-autocomplete
                  v-model="paymentParams.payment_method"
                  auto-select-first
                  :items="paymentMethodList"
                  hide-details="auto"
                  item-value="index"
                  outlined
                  dense
                  :rules="paymenthodRules"
                  placeholder="Pilih Metode Pembayaran"
                >
                  <template v-slot:selection="data">
                    <div class="d-flex flex-row align-center justify-left">
                      <div class="d-flex flex-row">
                        <span>{{ data.item.value }}</span>
                      </div>
                    </div>
                  </template>

                  <template v-slot:item="data">
                    <div class="d-flex flex-row align-center justify-left">
                      <div class="d-flex flex-row">
                        <span>{{ data.item.value }}</span>
                      </div>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="align-center mb-4">
              <v-col cols="12" sm="4" class="py-0">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Bank Pembayaran</div>
              </v-col>
              <v-col cols="12" sm="8" class="py-0">
                <v-autocomplete
                  v-model="paymentParams.purpose_bank"
                  auto-select-first
                  :items="bankAccountList"
                  hide-details="auto"
                  item-value="bank_account_bank_name"
                  item-text="bank_account_bank_name"
                  placeholder="Pilih rekening tujuan pembayaran"
                  outlined
                  return-object
                  dense
                  :rules="bankToRules"
                >
                  <template v-slot:selection="data">
                    <div class="d-flex flex-row align-center justify-left">
                      <div class="d-flex flex-row">
                        <strong
                          style="display: block; width: 100px;"
                        >{{ data.item.bank_account_bank_name }}</strong>
                        <div class="d-flex flex-column justify-left text-subtitle-2">
                          <span class="pl-3 font-weight-bold">{{ data.item.bank_account_name }}</span>
                          <span class="pl-3 font-weight-normal">{{ data.item.bank_account_number }}</span>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template v-slot:item="data">
                    <div class="d-flex flex-row align-center justify-left">
                      <div class="d-flex flex-row">
                        <strong
                          style="display: block; width: 100px;"
                        >{{ data.item.bank_account_bank_name }}</strong>
                        <div class="d-flex flex-column justify-left text-subtitle-2">
                          <span class="pl-3 font-weight-bold">{{ data.item.bank_account_name }}</span>
                          <span class="pl-3 font-weight-normal">{{ data.item.bank_account_number }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <hr />
            <br />

            <v-row class="align-center mb-4">
              <v-col cols="12" sm="4" class="py-0">
                <div class="d-block text-subtitle-2 font-weight-bold black--text mb-2">Bank Pengirim</div>
              </v-col>
              <v-col cols="12" sm="8" class="py-0">
                <v-autocomplete
                  v-model="paymentParams.from_bank_name"
                  :items="listBank"
                  hide-details="auto"
                  item-value="bank_name"
                  item-text="bank_name"
                  outlined
                  dense
                  :rules="acctBankRules"
                  placeholder="Pilih Bank Pengirim"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="align-center mb-4">
              <v-col cols="12" sm="4" class="py-0">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Cabang Bank Pengirim</div>
              </v-col>
              <v-col cols="12" sm="8" class="py-0">
                <v-text-field
                  v-model="paymentParams.from_bank_branch"
                  hide-details="auto"
                  dense
                  outlined
                  type="text"
                  :rules="acctbranchRules"
                  placeholder="Masukkan cabang bank pengirim"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="align-center mb-4">
              <v-col cols="12" sm="4" class="py-0">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Nama Rekening Pengirim</div>
              </v-col>
              <v-col cols="12" sm="8" class="py-0">
                <v-text-field
                  v-model="paymentParams.from_account_name"
                  hide-details="auto"
                  dense
                  outlined
                  type="text"
                  :rules="acctnameRules"
                  placeholder="Masukkan nama rekening pengirim"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="align-center mb-4">
              <v-col cols="12" sm="4" class="py-0">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Nomor Rekening Pengirim</div>
              </v-col>
              <v-col cols="12" sm="8" class="py-0">
                <v-text-field
                  v-model="paymentParams.from_account_number"
                  hide-details="auto"
                  dense
                  outlined
                  type="text"
                  :rules="acctrekRules"
                  placeholder="Masukkan nomor rekening pengirim"
                ></v-text-field>
              </v-col>
            </v-row>
            <hr />
            <br />

            <v-row class="align-center mb-4">
              <v-col cols="12" sm="4" class="py-0">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Tanggal Transfer</div>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <v-menu v-model="menuTransfer" :close-on-content-click="false" max-width="290">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model.number="dateText"
                      prepend-inner-icon="mdi-calendar"
                      clearable
                      readonly
                      hide-details="auto"
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      placeholder="Masukkan tanggal transfer"
                      :rules="tfdateRules"
                      @click:clear="paymentParams.transfer_date = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="paymentParams.transfer_date"
                    @change="menuTransfer = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="align-center mb-0">
              <v-col cols="12" sm="4" class="py-0">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text mb-2"
                >Jumlah Transfer</div>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <v-currency-field
                  v-model="paymentParams.transfer_value"
                  hide-details="auto"
                  outlined
                  dense
                  @keypress="onlyNumber"
                  :rules="tfvalueRules"
                  placeholder="Masukkan nominal transfer"
                >
                  <div slot="prepend-inner">
                    <span class="d-inline font-weight-bold mr-1 mt-1">Rp</span>
                  </div>
                </v-currency-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-text class="pt-2 pb-0 px-5 text-center" :class="(!isMobile) ? 'mx-1' : ''" v-else>
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 mb-3">
                Apakah Pembelian dengan No.
                <strong
                  class="black--text"
                >{{ (selectedItem) ? selectedItem.po_code : '' }}</strong> akan diproses pembayarannya ?
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions :class="(isMobile) ? 'px-3 text-center' : 'mt-5'">
          <v-row class="text-center">
            <hr />
            <v-col cols="12" class="px-5 pt-0">
              <v-btn
                outlined
                class="my-2 px-5 text-capitalize"
                :loading="loadingTransaksi"
                @click="cancelProcessPO"
                v-if="!isMobile"
              >Batal</v-btn>
              <v-btn
                color="black"
                :loading="loadingTransaksi"
                class="my-2 text-capitalize white--text"
                :class="(isMobile) ? 'v-btn--block' : 'px-5 ml-2'"
                @click="confirmPO(selectedItem.po_id)"
                v-if="!confirmPayment"
              >Lanjutkan</v-btn>
              <v-btn
                color="black"
                :loading="loadingTransaksi"
                class="my-2 px-5 text-capitalize white--text"
                :class="(isMobile) ? 'v-btn--block' : 'px-5 ml-2'"
                @click="pembayaranPO(selectedItem.po_id)"
                v-if="confirmPayment"
              >Proses</v-btn>
              <v-btn
                outlined
                class="my-2 text-capitalize"
                :class="(isMobile) ? 'v-btn--block' : 'px-5'"
                :loading="loadingTransaksi"
                @click="cancelProcessPO"
                v-if="isMobile"
              >Batal</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmReceive" persistent max-width="500">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text"
        >Konfirmasi Penerimaan Barang</v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1 text-center">
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 mb-3">
                Apakah Barang Pembelian dengan No.
                <strong
                  class="black--text"
                >{{ (selectedItem) ? selectedItem.po_code : '' }}</strong> sudah anda terima ?
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              class="my-2 px-5 text-capitalize"
              :loading="loadingTransaksi"
              @click="dialogConfirmReceive = false, selectedItem = null"
            >Tidak</v-btn>
            <v-btn
              color="black"
              :loading="loadingTransaksi"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="receivePO(selectedItem.po_id)"
            >Sudah Diterima</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatusPembelian" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">
          <v-img
            width="25"
            max-width="25"
            class="mr-2"
            src="/assets/seller/status-pesanan-no-padding.svg"
          ></v-img>Status Pembelian
        </v-card-title>
        <v-card-text class="py-0 px-5">
          <template v-if="detailPembelian">
            <v-row class="px-5 py-3 align-center">
              <v-col cols="12" sm="6">
                <div
                  class="d-block text-subtitle-1 font-weight-bold black--text"
                >{{ detailPembelian.po_code }}</div>
                <div
                  class="text-subtitle-2"
                >{{ formatDateText(detailPembelian.po_status_created_datetime, 'DD MMMM YYYY HH:mm') }}</div>
              </v-col>

              <v-col cols="12" sm="6" :class="{'text-right': !isMobile}">
                <v-chip
                  label
                  class="font-weight-bold"
                  :class="colorStatus(detailPembelian.po_status)"
                >{{ statusCaption(detailPembelian.po_status) }}</v-chip>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <hr />

            <div class="d-block py-5">
              <v-timeline align-top dense v-if="historyStatus">
                <template v-for="(log, idl) in historyStatus">
                  <v-timeline-item
                    :color="(log.po_status === detailPembelian.po_status) ? 'black' : 'grey darken-5'"
                    small
                    :key="idl"
                    v-if="log.po_status_datetime"
                  >
                    <v-row class="py-0">
                      <v-col cols="12" sm="4" class="py-0">
                        <span
                          class="grey--text"
                        >{{ formatDateText(log.po_status_datetime, 'DD MMMM YYYY HH:mm') }}</span>
                      </v-col>
                      <v-col class="py-0">
                        <div class="d-block font-weight-bold black--text">{{ log.po_status_desc }}</div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>
                </template>
              </v-timeline>
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="dialogStatusPembelian = false"
              class="my-2 px-5 text-capitalize"
            >Tutup</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- lacak pesanan -->
    <v-dialog v-model="lacakStatusPesanan" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">
          <v-icon>mdi-truck</v-icon>&nbsp;Lacak Pesanan
        </v-card-title>
        <v-card-text class="py-0 px-5">
          <!-- {{historyTrackingData}} -->
          <template v-if="detailPembelian">
            <v-row class="px-5 py-3 align-center">
              <!-- {{detailPembelian}} -->
              <v-col cols="12" sm="6">
                <div
                  class="d-block text-subtitle-1 font-weight-bold black--text"
                >{{ detailPembelian.po_code }}</div>
                <div
                  class="text-subtitle-2"
                >{{ formatDateText(detailPembelian.po_status_created_datetime, 'DD MMMM YYYY HH:mm') }}</div>
                <div class="text-subtitle-2">Kurir: {{detailPembelian.po_courier_code}}</div>
                <div class="text-subtitle-2">Resi: {{detailPembelian.po_courier_resi}}</div>
              </v-col>

              <v-col cols="12" sm="6" :class="(isMobile) ? 'text-left pt-0' : 'text-right'">
                <v-chip
                  v-if="detailPembelian.po_status=='completed'"
                  label
                  :class="colorStatus(detailPembelian.po_status)"
                >{{ statusCaption(detailPembelian.po_status) }}</v-chip>
                <v-chip
                  v-else-if="detailPembelian.delivery_status=='1'"
                  label
                  :class="colorStatus('completed')"
                >Telah Diterima</v-chip>
                <v-chip
                  v-else-if="historyTrackingData.length"
                  label
                  :class="colorStatus('on_delivery')"
                >{{ statusCaption("on_delivery") }}</v-chip>
                <v-chip
                  v-else
                  label
                  :class="colorStatus(detailPembelian.po_status)"
                >{{ statusCaption(detailPembelian.po_status) }}</v-chip>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <hr />

            <div class="d-block py-5">
              <v-timeline align-top dense v-if="historyTrackingData.length">
                <template v-for="(log, idl) in historyTrackingData">
                  <v-timeline-item
                    :color="(idl==0) ? 'black' : 'grey darken-5'"
                    small
                    :key="idl"
                    v-if="log.manifest_datetime"
                  >
                    <v-row class="py-0">
                      <v-col cols="12" sm="4" class="py-0">
                        <span
                          class="grey--text"
                        >{{ formatDateText(log.manifest_datetime, 'DD MMMM YYYY HH:mm') }}</span>
                      </v-col>
                      <v-col class="py-0">
                        <div
                          class="d-block font-weight-bold black--text"
                          :class="{'text-subtitle-2': isMobile}"
                        >
                          {{ log.manifest_description }}
                          <br />
                          <span class="grey--text">{{log.city_name}}</span>
                          <template v-if="detailTransaction.delivery_status=='1' && idl==0">
                            <br />
                            <span
                              class="grey--text"
                            >DELIVERY : {{detailTransaction.delivery_receiver}}</span>
                          </template>
                        </div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>
                </template>
              </v-timeline>
              <div v-else>
                <center>Sistem belum menerima data dari Ekspedisi, mohon ulangi beberapa saat lagi.</center>
              </div>
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="lacakStatusPesanan = false, selectedItem = null"
              class="my-2 px-5 text-capitalize"
            >Tutup</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import { midtransURL } from "@/config";
import { midtransKey } from "@/config";
export default {
  component: { moment },
  props: ["allowedStatus"],
  data() {
    return {
      lacakStatusPesanan: false,
      loadingBelanja: false,
      dialogConfirmBayar: false,
      dialogConfirmReceive: false,
      dialogStatusPembelian: false,
      loadingDetail: false,
      loadingStatus: false,
      loadingList: false,
      loadingTransaksi: false,
      confirmPayment: false,
      listPembelian: [],
      panel: [0],
      menuDate: false,
      menuTransfer: false,
      isMobile: false,
      filterOptions: [
        {
          label: "No. Pembelian",
          value: "ponum"
        }
      ],
      filter: {
        type: {
          label: "No. Pembelian",
          value: "ponum"
        },
        search: "",
        filterId: null,
        sortId: null,
        dateRange: null
      },
      selected: [],
      selectedItem: null,
      expanded: [],
      headers: [
        {
          text: "Info Pembelian",
          align: "start",
          sortable: false,
          value: "po_code"
        },
        { text: "action", value: "data-table-expand" }
      ],
      page: 1,
      limit: 5,
      sort: {},
      sortBy: "",
      sortDir: "",
      poNoFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "po_code"
      },
      tglTransaksiFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "po_status_created_datetime"
      },
      statusFilter: {
        value: "",
        comparison: "yes",
        type: "list",
        field: "po_status"
      },
      paymentMethods: [
        {
          index: "bank_transfer",
          value: "Bank Transfer"
        }
      ],
      historyStatus: null,
      paymentParams: {
        po_id: "",
        payment_method: "",
        purpose_bank: null,
        from_bank_name: "",
        from_bank_branch: "",
        from_account_name: "",
        from_account_number: "",
        transfer_value: "",
        transfer_date: null
      },
      bankToRules: [v => !!v || "Bank tidak boleh kosong"],
      paymenthodRules: [v => !!v || "Nomor rekening tidak boleh kosong"],
      acctBankRules: [v => !!v || "Nama rekening tidak boleh kosong"],
      acctbranchRules: [v => !!v || "Cabang bank tidak boleh kosong"],
      acctnameRules: [v => !!v || "Nama rekening tidak boleh kosong"],
      acctrekRules: [v => !!v || "Nomor rekening tidak boleh kosong"],
      tfdateRules: [v => !!v || "Tanggal transfer tidak boleh kosong"],
      tfvalueRules: [
        v => !!v || "Nominal transfer tidak boleh kosong",
        v =>
          parseFloat(v.replace(/\D/g, "")) >
            this.detailPembelian.po_price_grand_total - 1 ||
          `Jumlah yg dibayarkan kurang dari total pembelian senilai ${this.$options.filters.toRupiah(
            this.detailPembelian.po_price_grand_total
          )}`,
        v => parseInt(v) > 0 || "Nilai nominal transfer harus lebih dari 0"
      ]
    };
  },

  computed: {
    ...mapState("pembelianSeller", [
      "pembelianData",
      "pembelianPagination",
      "detailPembelian",
      "response",
      "responseError",
      "historyTrackingData"
    ]),
    ...mapState("options", [
      "courier",
      "listBank",
      "bankAccountList",
      "paymentMethodList"
    ]),
    ...mapState("storeSeller", ["detailStore"]),
    dateRangeText: {
      get() {
        let dates = this.filter.dateRange
          ? new Date(this.filter.dateRange)
          : null;
        return dates ? moment(dates).format("DD MMM YYYY") : null;
      },
      set() {
        let dates = this.filter.dateRange
          ? new Date(this.filter.dateRange)
          : null;
        return dates ? moment(dates).format("DD MMM YYYY") : null;
      }
    },
    dateText: {
      get() {
        let dates = this.paymentParams.transfer_date
          ? new Date(this.paymentParams.transfer_date)
          : null;
        return dates ? moment(dates).format("DD MMM YYYY") : null;
      },
      set() {
        let dates = this.paymentParams.transfer_date
          ? new Date(this.paymentParams.transfer_date)
          : null;
        return dates ? moment(dates).format("DD MMM YYYY") : null;
      }
    }
  },
  watch: {
    lacakStatusPesanan: {
      handler: function(val, oldVal) {
        // Log it
        if (val == true) {
          // console.log("detailPes:", this.detailPesanan);
          this.getDetailTracking(
            this.detailPembelian.po_code,
            this.detailPembelian.po_agregator,
            this.detailPembelian.order_id_kiriminaja
          );
          this.getDetailHistoryTracking(this.detailPembelian.po_code);
        }
        console.log("newVal", val, ("oldVal", oldVal));
      },
      deep: true
    }
  },
  async mounted() {
    await this.getListPembelian();
    this.getBankAccountList();
    this.getPaymentMethodList();
    this.getBankList();
    let midtrans = document.createElement("script");
    midtrans.setAttribute("src", midtransURL);
    midtrans.setAttribute("data-client-key", midtransKey);
    document.head.appendChild(midtrans);
  },

  methods: {
    getDetailHistoryTracking(trxCode) {
      let params = [];
      params = { po_code: trxCode };
      this.getHistoryTracking(params)
        .then(async () => {
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = true;
        });
    },
    async getDetailTracking(trxCode, agregator, oidKiriminaja) {
      let params = [];
      params = { po_code: trxCode, order_id: oidKiriminaja };
     console.log(agregator,oidKiriminaja)
     if (agregator == "kiriminaja") {
    //  console.log("getTrackingKiriminaja")

        await this.getTrackingKiriminaja(params)
          .then(async () => {
            this.loadingList = false;
          })
          .catch(() => {
            this.loadingList = true;
          });
      } else {
        await this.getTracking(params)
          .then(async () => {
            this.loadingList = false;
          })
          .catch(() => {
            this.loadingList = true;
          });
      }
    },
    ...mapActions("pembelianSeller", [
      "getPembelian",
      "getPembelianDetail",
      "bayarPembelian",
      "receivePembelian",
      "getStatusPembelian",
      "choosePayment",
      "saveSnap",
      "notificationPembelian",
      "cancelMidtrans",
      "getHistoryTracking",
      "getTracking",
      "getTrackingKiriminaja",
    ]),
    ...mapActions("options", [
      "getBankList",
      "getBankAccountList",
      "getPaymentMethodList"
    ]),
    ...mapActions("storeSeller", ["getStoreDetail"]),
    ...mapMutations(["makeAlert"]),

    async doCancel(item) {
      this.loadingBelanja = await true;

      let params = await {
        invoice: item.po_code
      };
      await this.cancelMidtrans(params)
        .then(() => {
          this.makeAlert({
            code: "success",
            type: "success",
            message: "Transaksi berhasil dibatalkan",
            show: true
          });
          this.loadingBelanja = false;
          this.getListPembelian();
        })
        .catch(() => {
          this.loadingBelanja = false;
          this.getListPembelian();
        });
    },
    async openPayment(item) {
      this.loadingBelanja = await true;

      let params = await {
        po_code: item.po_code
      };
      await this.choosePayment(params)
        .then(async data => {
          let dataItem = item;
          var that = this;
          let notificationPembelian = this.notificationPembelian;
          let saveSnap = await this.saveSnap;
          console.log("ataItem", dataItem);
          snap.pay(data.data.data.token, {
            onSuccess: function(result) {
              console.log("success", result);
              notificationPembelian(result);
              saveSnap(result).then(() => {
                console.log("success:::", result.pdf_url);
                console.log(
                  "result.finish_redirect_url:::",
                  result.finish_redirect_url
                );

                that.makeAlert({
                  code: "success",
                  type: "success",
                  message: this.response.message,
                  show: true
                });
                // that.clearPO();
                that.loadingBelanja = false;
                // that.$router.push({
                //   name: "seller-pembelian"
                // });
                that.getListPembelian();
              });
            },
            onPending: function(result) {
              console.log("pending", result);
              notificationPembelian(result);
              saveSnap(result).then(() => {
                console.log("pennding:::", result.pdf_url);
                console.log(
                  "result.finish_redirect_url:::",
                  result.finish_redirect_url
                );

                that.loadingBelanja = false;

                // window.open(result.pdf_url);
                // window.location = result.finish_redirect_url;
                // that.makeAlert({
                //   code: "success",
                //   type: "success",
                //   message: this.response.message,
                //   show: true
                // });
                // that.clearPO();
                // that.loadingBelanja = false;
                // that.$router.push({
                //   name: "seller-pembelian"
                // });
                that.getListPembelian();
              });
            },
            onError: function(result) {
              that.loadingBelanja = false;
              console.log("error", result);
              saveSnap(result);
              that.loadDetailPembelian(dataItem);

              // router.push({
              //   name: "seller-pembelian"
              // });
            },
            onClose: function(result) {
              that.loadingBelanja = false;
              that.getListPembelian();

              console.log("cancel", data, result);
              console.log(
                "customer closed the popup without finishing the payment"
              );
            }
          });
        })
        .catch(() => {
          // console.log("respError", respError);
          // this.validationError({
          //   error_validation: "Data tidak ditemukan"
          // });
          this.getListPembelian();
          this.makeAlert({
            code: "error",
            type: "error",
            message: "Data tidak ditemukan",
            show: true
          });
          this.loadingBelanja = false;
        });
    },
    async getListPembelian() {
      this.loadingList = await true;
      let params = await [];
      let status = "";

      for (let i = 0; i < this.allowedStatus.length; i++) {
        status +=
          i < this.allowedStatus.length - 1
            ? this.allowedStatus[i] + "::"
            : this.allowedStatus[i];
      }
      this.statusFilter.value = await status;
      if (this.statusFilter.value) params.push(this.statusFilter);

      this.page = await 1;
      await this.getPembelian(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: params
        })
      )
        .then(async () => {
          this.listPembelian = await this.pembelianData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = true;
        });
    },

    filterAllowedStatus(data) {
      let showList = data.filter(d => this.allowedStatus.includes(d.po_status));
      return showList;
    },

    formatDateText(params, format) {
      let dates = params ? new Date(params) : null;
      return dates ? moment(dates).format(format) : null;
    },

    async clearDate() {
      this.filter.dateRange = await null;
      this.tglTransaksiFilter.value = await this.filter.dateRange;
      this.searchPO();
    },

    statusCaption(status) {
      if (status === "created") return "Pembelian Baru";
      else if (status === "pending") return "Menunggu Verifikasi";
      else if (status === "paid") return "Pembayaran Disetujui";
      else if (status === "pickup") return "Permintaan Pickup";
      else if (status === "delivery") return "Sedang Diantar";
      else if (status === "processed") return "Sedang Diproses";
      else if (status === "completed") return "Sudah Selesai";
      else if (status === "rejected") return "Dibatalkan";
      else if (status === "cancel") return "Dibatalkan";
    },

    colorStatus(status) {
      if (status === "paid") return "black white--text";
      else if (status === "pending") return "orange darken-1 white--text";
      else if (status === "processed") return "blue darken-1 white--text";
      else if (status === "on_delivery")
        return "deep-purple darken-1 white--text";
      else if (status === "completed")
        return "light-black darken-4 white--text";
      else if (status === "rejected") return "red white--text";
      else if (status === "cancel") return "red white--text";
    },

    async loadDetailPembelian({ item }) {
      this.loadingDetail = await true;
      const params = await {
        po_id: item.po_id
      };
      await this.getPembelianDetail(params).then(async () => {
        this.paymentParams.transfer_date = await this.formatDateText(
          new Date(),
          "YYYY-MM-DD"
        );
        this.paymentParams.transfer_value = await this.detailPembelian
          .po_price_grand_total;

        const histories = [
          {
            po_status: "created",
            po_status_datetime: this.detailPembelian.po_status_created_datetime,
            po_status_desc: "Anda telah berhasil melakukan pemesanan Barang."
          },
          {
            po_status: "pending",
            po_status_datetime: this.detailPembelian.po_status_pending_datetime,
            po_status_desc:
              "Pembayaran Anda Berhasil. Pembayaran akan diverifikasi terlebih dulu oleh Admin."
          },
          {
            po_status: "paid",
            po_status_datetime: this.detailPembelian.po_status_paid_datetime,
            po_status_desc:
              "Pembayaran sudah diverifikasi. Pemesanan Barang Anda akan diproses ke pengiriman."
          },
          {
            po_status: "processed",
            po_status_datetime: this.detailPembelian
              .po_status_processed_datetime,
            po_status_desc:
              "Hore ! Barang Anda sedang diproses oleh Penjual untuk segera dikirimkan ke alamat Anda."
          },
          {
            po_status: "pickup",
            po_status_datetime: this.detailPembelian.po_status_pickup_datetime,
            po_status_desc:
              "Barang Anda sedang menunggu Pickup Kurir untuk segera dikirimkan ke alamat Anda."
          },
          {
            po_status: "delivery",
            po_status_datetime: this.detailPembelian
              .po_status_delivery_datetime,
            po_status_desc:
              "Barang Anda sedang dikirim oleh Kurir ke alamat Anda."
          },
          {
            po_status: "completed",
            po_status_datetime: this.detailPembelian
              .po_status_completed_datetime,
            po_status_desc: "Pemesanan Barang Anda telah diterima."
          },
          {
            po_status: "cancel",
            po_status_datetime: this.detailPembelian.po_status_cancel_datetime,
            po_status_desc: "Pemesanan Anda telah dibatalkan."
          },
          {
            po_status: "rejected",
            po_status_datetime: this.detailPembelian
              .po_status_rejected_admin_datetime,
            po_status_desc: "Pemesanan Anda tidak disetujui."
          }
        ];
        const sortedActivities = histories.sort((a, b) => {
          if (a.po_status_datetime > b.po_status_datetime) return -1;
          if (a.po_status_datetime < b.po_status_datetime) return 1;
          return 0;
        });
        this.historyStatus = sortedActivities;
      });
      this.loadingDetail = false;
    },

    setSlugProduct(id, nama) {
      return id + "-" + nama.toLowerCase().replace(/ /g, "-");
    },

    async searchPO() {
      this.loadingList = await true;
      let params = await [];

      if (this.poNoFilter.value) await params.push(this.poNoFilter);
      if (this.tglTransaksiFilter.value)
        await params.push(this.tglTransaksiFilter);

      if (this.allowedStatus.length === 1)
        this.statusFilter.value = await this.allowedStatus;
      if (this.statusFilter.value) await params.push(this.statusFilter);

      this.page = await 1;
      await this.getPembelian(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: params
        })
      )
        .then(async () => {
          this.listPembelian = await this.filterAllowedStatus(
            this.pembelianData
          );
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = false;
        });
    },

    async clearSearch() {
      this.filter.search = await "";
      this.filter.type = await {
        label: "No. Pembelian",
        value: "ponum"
      };
      this.poNoFilter.value = await "";
      this.searchPO();
    },

    async updatePage(val) {
      this.loadingList = await true;
      let params = await [];
      let status = "";

      for (let i = 0; i < this.allowedStatus.length; i++) {
        status +=
          i < this.allowedStatus.length - 1
            ? this.allowedStatus[i] + "::"
            : this.allowedStatus[i];
      }
      this.statusFilter.value = await status;
      if (this.statusFilter.value) params.push(this.statusFilter);

      await this.getPembelian(
        this.queryString({ limit: 5, page: val, params: params })
      )
        .then(async () => {
          this.listPembelian = await this.pembelianData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = false;
        });
    },

    async openConfirmBayar(item) {
      this.selectedItem = await item;
      this.dialogConfirmBayar = true;
    },

    async openConfirmReceive(item) {
      this.selectedItem = await item;
      this.dialogConfirmReceive = true;
    },

    cancelProcessPO() {
      this.confirmPayment = false;
      this.selectedItem = null;
      this.paymentParams = {
        po_id: "",
        payment_method: "",
        purpose_bank: null,
        from_bank_name: "",
        from_bank_branch: "",
        from_account_name: "",
        from_account_number: "",
        transfer_value: this.detailPembelian.po_price_grand_total,
        transfer_date: new Date()
      };
      this.dialogConfirmBayar = false;
    },

    confirmPO(id) {
      if (this.$refs.formPayment.validate()) {
        this.paymentParams.po_id = id;
        this.confirmPayment = true;
      }
    },

    async pembayaranPO(id) {
      this.loadingTransaksi = await true;
      let params = await {
        po_id: id,
        payment_method: this.paymentParams.payment_method,
        to_bank_name: this.paymentParams.purpose_bank.bank_account_bank_name,
        to_bank_branch: this.paymentParams.purpose_bank
          .bank_account_bank_branch,
        to_account_name: this.paymentParams.purpose_bank.bank_account_name,
        to_account_number: this.paymentParams.purpose_bank.bank_account_number,
        from_bank_name: this.paymentParams.from_bank_name,
        from_bank_branch: this.paymentParams.from_bank_branch,
        from_account_name: this.paymentParams.from_account_name,
        from_account_number: this.paymentParams.from_account_number,
        transfer_value: this.paymentParams.transfer_value,
        transfer_datetime: new Date(this.paymentParams.transfer_date)
      };
      this.bayarPembelian(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true
          });
          await this.getListPembelian();
          await this.getStatusPembelian();
          this.selectedItem = await null;
          this.dialogConfirmBayar = await false;
          this.loadingTransaksi = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmBayar = false;
          this.loadingTransaksi = false;
        });
    },

    async receivePO(id) {
      this.loadingTransaksi = await true;
      let params = await {
        po_id: id
      };
      this.receivePembelian(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true
          });
          await this.getListPembelian();
          await this.getStatusPembelian();
          this.selectedItem = await null;
          this.dialogConfirmReceive = await false;
          this.loadingTransaksi = false;
        })
        .catch(() => {
          this.makeAlert({
            code: "error",
            type: "error",
            message:
              "Ada masalah saat upload gambar, periksa kembali file anda. Pastikan sesuai dengan requirement yang diminta.",
            show: true
          });
          this.selectedItem = null;
          this.dialogConfirmReceive = false;
          this.loadingTransaksi = false;
        });
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },

    printInvoice(id) {
      let routeData = this.$router.resolve({
        path: "/seller/invoice_po/" + id
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.v-spacer {
  width: 1px;
  height: 30px;
  background: transparent;
  display: block;
  position: relative;
  margin: 0 auto;
  border-left: 3px dotted #ccc;
}
</style>